/* eslint-disable no-console */

export default class WakeLockService {
  private wakeLock?: WakeLockSentinel
  navigator: Pick<Navigator, 'wakeLock'>
  isSupported = false

  constructor(navigator: Pick<Navigator, 'wakeLock'> = window.navigator) {
    this.navigator = navigator
    this.checkSupport()
  }

  private checkSupport() {
    if ('wakeLock' in this.navigator) {
      this.isSupported = true
    }
  }

  async lockScreen() {
    if (!this.isSupported) {
      console.warn('Wake lock API is not supported by your browser.')

      return
    }

    if (this.wakeLock?.released) {
      return
    }

    try {
      this.wakeLock = await this.navigator.wakeLock.request('screen')

      console.log('%cWake lock is active!', 'color: green;')
    } catch (err) {
      if (err instanceof Error) {
        console.warn(`${err.name}, ${err?.message}`)
      } else {
        console.warn(err)
      }
    }
  }
}
